import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#030308] py-16 px-4 border-t border-white/5" data-id="element-103">
      <div className="max-w-4xl mx-auto text-center" data-id="element-104">
        <div className="text-white text-3xl font-black tracking-widest mb-6 flex items-center justify-center gap-3" data-id="element-105">
          <span className="text-4xl" data-id="element-106">🎨</span> EDULABS™ Italia
        </div>

        <p className="text-white/80 text-lg leading-relaxed mb-3 max-w-xl mx-auto font-medium" data-id="element-107">
          Risorse d'eccellenza per la Scuola Secondaria.
        </p>
        <p className="text-white/70 text-sm italic mb-10" data-id="element-108">
          Perché insegnare arte non dovrebbe toglierti i tuoi momenti di relax.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-white/80 mb-10" data-id="element-109">
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-110">
            <span data-id="element-111">📧</span> supporto.edulabs@gmail.com
          </span>
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-112">
            <span data-id="element-113">📲</span> @edulabs.italia
          </span>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-114" />

        <p className="text-white/60 text-xs tracking-wider" data-id="element-115">
          © EDULABS™ 2026 — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}